export default __webpack_public_path__ + "static/side-nav-dont-8-ab9e51eebb6749b6142d6b923eaf35cb0a917366105e97c5a38c4403f206d657.png";